module.exports = __webpack_public_path__ + "static/media/logicartslogo.78783b7e.jpeg";